import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/plugins/vue-i18n'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#25BECB',
        secondary: '#5c7c6c',
        accent: '#8c9eff',
        error: '#b71c1c'
      }
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
})
